import LoopIcon from "@material-ui/icons/Loop";
import AdhocOperatorList from "./AdhocOperatorList";
import AdhocOperatorShow from "./AdhocOperatorShow";
import AdhocOperatorCreate from "./AdhocOperatorCreate";
import AdhocOperatorEdit from "./AdhocOperatorEdit";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "adhocOperators",
  list: AdhocOperatorList,
  show: AdhocOperatorShow,
  create: AdhocOperatorCreate,
  edit: AdhocOperatorEdit,
  icon: LoopIcon,
};
